import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { uiActions } from '../../actions';
import useDispatch from '../../hooks/useDispatch';
import useRegion from '../../hooks/useRegion';
import useSelector from '../../hooks/useSelector';
import ShortkeyListener from './ShortkeyListener';

const NavigateShortkeys: React.FC = () => {
  const [t] = useTranslation();
  const region = useRegion();
  const nagivate = useNavigate();
  const dispatch = useDispatch();
  const { showQuestionMarks } = useSelector(state => state.ui.floatTutorial);

  const callback = useCallback(
    key => {
      if (key === 'h') {
        if (showQuestionMarks) {
          dispatch(uiActions.floatTutorial.hideQuestionMarks());
        } else {
          dispatch(uiActions.floatTutorial.showQuestionMarks());
        }
        return;
      }

      const path = (() => {
        switch (key) {
          case 'l': {
            return 'lookup';
          }
          case 'c': {
            return 'ccass';
          }
          case 'r': {
            return 'ranking';
          }
          case 's': {
            return 'signal';
          }
          default: {
            return '';
          }
        }
      })();

      nagivate(`/${region}/${path}`);
    },
    [dispatch, nagivate, region, showQuestionMarks]
  );

  const handleKeys = useMemo(
    () => ['l', ...(region === 'hk' ? ['c'] : []), 's', 'r', 'h'],
    [region]
  );
  const shortkeys = useMemo(
    () => [
      {
        section: 'global',
        key: 'L',
        description: t('go-to-lookup'),
      },
      ...(region === 'hk'
        ? [
            {
              section: 'global',
              key: 'C',
              description: t('go-to-ccass'),
            },
          ]
        : []),
      {
        section: 'global',
        key: 'S',
        description: t('go-to-signal'),
      },
      {
        section: 'global',
        key: 'R',
        description: t('go-to-ranking'),
      },
      {
        section: 'global',
        key: 'H',
        description: t('show-help-buttons'),
      },
    ],
    [region, t]
  );

  return (
    <ShortkeyListener
      handleKeys={handleKeys}
      onKeyEvent={callback}
      shortkeys={shortkeys}
    />
  );
};

export default React.memo(NavigateShortkeys);
